import { addMessages } from '@hana/i18n';

// Chuỗi giao diện (mã nghiệp vụ, tên riêng, dữ liệu mẫu không dịch).
addMessages('vi', {
  'bl.retry': 'Thử lại',
  'bl.viewOnlyRel': 'Chỉ xem · công nợ bị ẩn, không duyệt được release.',
  'bl.viewOnlyRole': 'Chỉ xem · công nợ khách và nút duyệt release bị khoá với vai trò của bạn.',
  'bl.flow': 'Luồng duyệt',
  'bl.missing': 'Còn thiếu:',
  'bl.sendSno': 'Gửi SNO',
  'bl.loiFromTpl': 'Tạo LOI từ mẫu',
  'bl.noDraft': 'Chưa gửi Draft nào',
  'bl.fieldCol': 'Trường',
  'bl.fblAutoClose': 'Task FBL tự đóng khi gửi thành công',
  'bl.loiAuto': 'Tự điền: số HBL/MBL, tàu/chuyến, POL/POD, shipper, consignee, notify, container/seal, ngày, người ký → xuất PDF (PrintKit). Đổi mẫu = phiên bản mới; job đang chạy giữ phiên bản đã sinh.',
  'bl.rejected': 'Đã từ chối · trả về CS',
  'bl.relBlocked': 'Chưa gửi được Release Confirmation · còn thiếu',
  'bl.noOpenTask': 'Không còn việc mở',
  'bl.jobDetail': 'Chi tiết job ↗',
  'bl.viewPrint': 'Xem bản in ↗',
  'bl.compareVer': 'So sánh phiên bản',
  'bl.csIssue': 'CS lập & phát hành · nhận xử lý',
  'bl.unassigned': 'Chưa giao',
  'bl.crossCheck': 'Soát chéo · được giao',
  'bl.editBl': 'Soạn / sửa B/L',
  'bl.jobBooking': 'Booking của job',
  'bl.backToList': 'Về danh sách',
  'bl.offFlow': 'B/L gửi ngoài luồng',
  'bl.logToJob': 'Ghi nhận vào job',
  'bl.noRelPending': 'Không còn release chờ bạn duyệt.',
  'bl.myStep': 'Bước của tôi:',
  'bl.selfApprove': 'Tự duyệt · ghi vào báo cáo tháng',
  'bl.approve': 'Duyệt',
  'bl.viewDetail': 'Xem chi tiết',
  'bl.autoUpper': 'Tự viết hoa',
  'bl.fromBooking': 'Lấy theo booking',
  'bl.viewOnlyJob': 'Chỉ xem: bạn không phụ trách chứng từ của job này.',
  'bl.validate': 'Kiểm tra',
  'bl.matchSi': 'Đối chiếu SI',
  'bl.askCustomer': 'Hỏi khách',
  'bl.statusApprove': 'Trạng thái & duyệt',
  'bl.docTasks': 'Việc chứng từ',
  'bl.history': 'Lịch sử',
  'bl.compare': 'So phiên bản',
  'bl.askHana': 'Ask HANA đề xuất',
  'bl.importXls': 'Nhập Excel',
  'bl.submitVgm': 'Nộp VGM',
  'bl.addCont': 'Thêm container',
  'bl.feesTitle': 'Phí & chi phí của B/L',
  'bl.edit': 'Sửa',
  'bl.svcFees': 'Phí dịch vụ',
  'bl.payReq': 'Đề nghị thanh toán',
  'bl.freeTime': 'Free time DEM / DET tại POD',
  'bl.printLine': 'Dòng in trên B/L',
  'bl.printFree': 'In dòng free time lên B/L',
  'bl.uploadFinal': 'Tải lên Final B/L',
  'bl.otherDocs': 'Chứng từ khác',
  'bl.blockSend': 'chặn gửi',
  'bl.attached': 'Đã kèm',
  'bl.notNeeded': 'Không cần',
  'bl.filter': 'Lọc',
  'bl.billType': 'Loại bill',
  'bl.isOneOf': 'là một trong',
  'bl.carrier': 'Hãng tàu',
  'bl.clear': 'Xoá',
  'bl.offFlow1': '1 B/L gửi ngoài luồng',
  'bl.offFlowMeta': '· HBL HNSGN260616460 · THUỶ → DuyNhut · Outlook 22/Oct 08:12 · chưa ghi phiên bản',
  'bl.viewOnlyMoney': 'Chỉ xem: số công nợ và nút duyệt release bị khoá.',
  'bledit.create': 'Tạo B/L',
  'bledit.noBl': 'Job này chưa có B/L',
  'bledit.noBlSub': 'Tạo từ booking, hoặc để Ask HANA đọc SI rồi điền sẵn.',
  'bledit.noBlChip': 'Chưa có B/L',
  'bledit.delRow': 'Xoá dòng',
  'bledit.delRowN': 'Xoá container dòng {n}',
  'bl.hideWarn': 'Ẩn cảnh báo',
  'bl.closePanel': 'Đóng bảng',
  'bl.offFlowBox': 'HANA Box: THUỶ gửi file HBL HNSGN260616460 từ Outlook cho DuyNhut lúc 22/Oct/2026 08:12',
});

addMessages('en', {
  'bl.retry': 'Retry',
  'bl.viewOnlyRel': 'View only · receivables hidden, cannot approve release.',
  'bl.viewOnlyRole': 'View only · customer receivables and the release approval button are locked for your role.',
  'bl.flow': 'Approval flow',
  'bl.missing': 'Missing:',
  'bl.sendSno': 'Send SNO',
  'bl.loiFromTpl': 'Create LOI from template',
  'bl.noDraft': 'No Draft sent yet',
  'bl.fieldCol': 'Field',
  'bl.fblAutoClose': 'FBL task closes automatically on successful send',
  'bl.loiAuto': 'Auto-filled: HBL/MBL no., vessel/voyage, POL/POD, shipper, consignee, notify, container/seal, dates, signer → export PDF (PrintKit). Changing the template = new version; running jobs keep the generated version.',
  'bl.rejected': 'Rejected · returned to CS',
  'bl.relBlocked': 'Release Confirmation cannot be sent yet · missing',
  'bl.noOpenTask': 'No open tasks',
  'bl.jobDetail': 'Job details ↗',
  'bl.viewPrint': 'View print ↗',
  'bl.compareVer': 'Compare versions',
  'bl.csIssue': 'CS prepares & issues · takes the case',
  'bl.unassigned': 'Unassigned',
  'bl.crossCheck': 'Cross-check · assigned',
  'bl.editBl': 'Draft / edit B/L',
  'bl.jobBooking': 'Job booking',
  'bl.backToList': 'Back to list',
  'bl.offFlow': 'B/L sent off-flow',
  'bl.logToJob': 'Log to job',
  'bl.noRelPending': 'No release waiting for your approval.',
  'bl.myStep': 'My step:',
  'bl.selfApprove': 'Self-approve · logged in monthly report',
  'bl.approve': 'Approve',
  'bl.viewDetail': 'View details',
  'bl.autoUpper': 'Auto uppercase',
  'bl.fromBooking': 'Take from booking',
  'bl.viewOnlyJob': 'View only: you are not in charge of this job\'s documents.',
  'bl.validate': 'Validate',
  'bl.matchSi': 'Match SI',
  'bl.askCustomer': 'Ask customer',
  'bl.statusApprove': 'Status & approval',
  'bl.docTasks': 'Document tasks',
  'bl.history': 'History',
  'bl.compare': 'Compare versions',
  'bl.askHana': 'Ask HANA suggests',
  'bl.importXls': 'Import Excel',
  'bl.submitVgm': 'Submit VGM',
  'bl.addCont': 'Add container',
  'bl.feesTitle': 'B/L fees & costs',
  'bl.edit': 'Edit',
  'bl.svcFees': 'Service fees',
  'bl.payReq': 'Payment request',
  'bl.freeTime': 'Free time DEM / DET at POD',
  'bl.printLine': 'Line printed on B/L',
  'bl.printFree': 'Print free-time line on B/L',
  'bl.uploadFinal': 'Upload Final B/L',
  'bl.otherDocs': 'Other documents',
  'bl.blockSend': 'blocks sending',
  'bl.attached': 'Attached',
  'bl.notNeeded': 'Not needed',
  'bl.filter': 'Filter',
  'bl.billType': 'Bill type',
  'bl.isOneOf': 'is one of',
  'bl.carrier': 'Carrier',
  'bl.clear': 'Clear',
  'bl.offFlow1': '1 B/L sent off-flow',
  'bl.offFlowMeta': '· HBL HNSGN260616460 · THUỶ → DuyNhut · Outlook 22/Oct 08:12 · version not logged',
  'bl.viewOnlyMoney': 'View only: receivable figures and the release approval button are locked.',
  'bledit.create': 'Create B/L',
  'bledit.noBl': 'This job has no B/L yet',
  'bledit.noBlSub': 'Create from the booking, or let Ask HANA read the SI and pre-fill.',
  'bledit.noBlChip': 'No B/L',
  'bledit.delRow': 'Delete row',
  'bledit.delRowN': 'Delete container row {n}',
  'bl.hideWarn': 'Hide warning',
  'bl.closePanel': 'Close panel',
  'bl.offFlowBox': 'HANA Box: THUỶ sent HBL file HNSGN260616460 from Outlook to DuyNhut on 22/Oct/2026 08:12',
});
